export default __webpack_public_path__ + "static/media/positions.dac996e3.mp3";